// extracted by mini-css-extract-plugin
export var statItem = "_kd-1";
export var statsRow = "_kd-0";